<template>
    <div class="qi-jiao">
        <div class="qi-jiao-top">
            <!-- 背景图 -->
            <div class="bid-inner">
                <div class="bid-title">企业教培考核数字化解决方案</div>
                <div class="bid-bg"></div>
            </div>
        </div>

        <div class="qi-cont">
            <div class="qi-cont-top">
                <div class="inner">
                    <p class="title">{{ bidText.title }}</p>
                    <p>{{ bidText.p1 }}</p>
                    <p v-if="bidText.p2">{{ bidText.p2 }}</p>

                    <div class="img-list">
                        <img :src="item" alt="" v-for="(item, i) in topImgList" :key="i" />
                    </div>
                </div>
            </div>

            <div class="qi-cont-bot">
                <div class="inner">
                    <myItem2 title="解决问题" :data="gdata"></myItem2>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import myItem2 from './components/my-item2.vue';
import CONFIG_PROJECT from '@config/project';

export default {
    head: {
        title: `产品和服务·${CONFIG_PROJECT.title}`,
    },
    name: '',
    components: { myItem2 },
    data() {
        return {
            bidText: {
                title: '企业教培考核数字化解决方案',
                p1: '为政企单位量身定制的的线上培训及考核一体化专业解决方案，可以全方位满足业务、技能培训，降低培训成本，提高培训效率。',
            },
            topImgList: [
                '/images/products/qi-jiao/qj-1.png',
                '/images/products/qi-jiao/qj-2.png',
                '/images/products/qi-jiao/qj-3.png',
            ],
            gdata: [
                {
                    img: '/images/products/qi-jiao/j1.png',
                    title: '点播学习',
                    text: '学员可根据情况选择对应课程',
                },
                {
                    img: '/images/products/qi-jiao/j2.png',
                    title: '形式丰富',
                    text: '视频、文档、图文、线下、直播、题库、试卷等多种课程，全方位满足培训要求',
                },
                {
                    img: '/images/products/qi-jiao/j3.png',
                    title: '学习打卡',
                    text: '掌握学员出勤情况',
                },

                {
                    img: '/images/products/qi-jiao/j4.png',
                    title: '必须选修',
                    text: '课程优先级设置，主次分明',
                },
                {
                    img: '/images/products/qi-jiao/j5.png',
                    title: '题库管理',
                    text: '支持单选、多选、判断、填空、简答、综合等多种题型批量导入',
                },
                {
                    img: '/images/products/qi-jiao/j6.png',
                    title: '杜绝舞弊',
                    text: '考试过程防挂机、防代考、防作弊、防切屏、系统自动阅卷',
                },

                {
                    img: '/images/products/qi-jiao/j7.png',
                    title: '学分统计',
                    text: '学习进度，成绩排名等信息进行统计',
                },
                {
                    img: '/images/products/qi-jiao/j8.png',
                    title: '电子证书',
                    text: '对考试合格的学员颁发电子合格证书，扫码可验真伪',
                },
                {
                    img: '/images/products/qi-jiao/j9.png',
                    title: '资料下载',
                    text: '课件、作业等资料随时下载保存',
                },
            ],
        };
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.qi-jiao {
    background-color: #fff;
    width: 100%;
    min-height: 1000px;
    position: relative;
    .qi-jiao-top {
        z-index: 0;
        width: 100%;
        height: 360px;
        background: url('/images/products/erji-bg.png') no-repeat;
        background-size: 100% 100%;
        background-size: cover;

        .bid-inner {
            width: 1200px;
            height: 120px;
            margin: 0 auto;
            position: relative;
            .bid-title {
                width: 630px;
                color: #fff;
                font-weight: bold;
                font-size: 38px;
                position: absolute;
                top: 85px;
                left: 0;
            }
            .bid-bg {
                z-index: 10;
                position: absolute;
                top: 40px;
                right: 36px;
                width: 370px;
                height: 283px;
                background: url('/images/products/qi-jiao/bg.png') no-repeat;
                background-size: 100% 100%;
                background-size: cover;
            }
        }
    }

    .qi-cont {
        .qi-cont-top {
            padding: 30px 0;
            width: 100%;
            background-color: #f6fbfe;
            p {
                // font-weight: bold;
                font-size: 15px;
                color: #131415;
                margin: 30px 0;
                text-align: center;
            }
            .title {
                font-size: 24px;
                font-weight: bold;
                color: #131415;
            }
            .img-list {
                display: flex;
                justify-content: space-around;
                img {
                    width: 367px;
                    height: 206px;
                    margin: 20px 0 30px;
                    transition: all 0.3s;
                    cursor: pointer;
                    &:hover {
                        transform: scale(1.1);
                    }
                }
            }
        }

        .qi-cont-bot {
            display: flex;
            justify-content: space-between;
            margin-top: 20px;
            padding-bottom: 20px;
        }
    }

    .inner {
        width: 1200px;
        margin: 0 auto;
    }
}
</style>
